import * as ngCore from '@angular/core'

import * as state from '../../../../../../state'

import * as jumbotron from './jumbotron'
import * as sections from './sections'

/**
 * Page in Summit used to give a pulse check on how the team is doing
 */
@ngCore.Component({
  encapsulation: ngCore.ViewEncapsulation.None,
  imports: [
    jumbotron.Component,
    sections.employees.Component,
    sections.highlights.Component,
    sections.outcomes.Component,
    sections.teamSpirit.Component,
    sections.teamMemberOverview.Component,
    sections.breakdown.Component,
  ],
  selector: 'atn-summit-pulse-page',
  standalone: true,
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component implements ngCore.OnInit {
  /** {@link state.summit.pulse.Feature} */
  public readonly pulseFeature = ngCore.inject(state.summit.pulse.Feature)

  /**
   * Conveys to {@link state.summit.pulse.Feature} that the user has opened this
   * page
   */
  public ngOnInit(): void {
    this.pulseFeature.actions.view.from('SummitPulsePage.OnInit').dispatch()
  }
}
